import React, { useState } from 'react';
import { metricKeyOfCard } from '../../utils/storeKpis';

const FOLDED = 6;

/** 金額が大きい店舗の数字（¥4,485,638 など）が、3 列の枠に収まるよう、長さで文字の大きさを変える。 */
const valueSizeClass = (value) => {
  const len = String(value ?? '').length;
  if (len >= 12) return ' sv-val--xl';
  if (len >= 10) return ' sv-val--l';
  return '';
};

/**
 * 店舗の KPI カード（ホームと同じ項目・同じ並び）。6 枚 ＋「もっと見る」で全項目。
 * カードをタップすると、グラフがその指標に切り替わる（グラフの無い項目は、タップしても何も起きない）。
 * 比較は「先月同時期」（cards = utils/storeKpis.storeKpiCards の結果）。
 */
export default function StoreKpiCards({ cards, metricKey, availableMetrics, onPick, headcount }) {
  const [expanded, setExpanded] = useState(false);
  if (!cards?.length) return null;
  const shown = expanded ? cards : cards.slice(0, FOLDED);

  return (
    <section className="sv-kpis" aria-label="KPI">
      <div className="section-title">
        KPI
        <span className="muted">
          {headcount != null ? `在籍 ${headcount}名 · ` : ''}比較は先月同時期
        </span>
      </div>
      <div className="sc-grid">
        {shown.map((c) => {
          const mapped = metricKeyOfCard(c);
          const pickable = Boolean(mapped) && (availableMetrics ? availableMetrics.includes(mapped) : true);
          const active = pickable && mapped === metricKey;
          return (
            <button
              key={c.key}
              type="button"
              className={`sc-card${active ? ' sc-card--active' : ''}`}
              aria-pressed={active}
              onClick={() => pickable && onPick?.(mapped)}
            >
              <div className="sc-label">{c.label}</div>
              <div className={`sc-val${valueSizeClass(c.value)}`}>{c.value}</div>
              <div className="sc-cmp" title="先月同時期との差">
                <span className={`sc-delta ${c.toneP}`}>{c.prev}</span>
              </div>
            </button>
          );
        })}
      </div>
      {cards.length > FOLDED && (
        <button type="button" className="sc-more" onClick={() => setExpanded((v) => !v)} aria-expanded={expanded}>
          {expanded ? (
            <span>閉じる</span>
          ) : (
            <span>
              もっと見る <span className="sc-more-n">+{cards.length - FOLDED}</span>
            </span>
          )}
        </button>
      )}
    </section>
  );
}
